/* @flow */
import * as React from 'react';

const Toys = props => (
  <svg
    width={113}
    height={93}
    viewBox="0 0 113 93"
    fill="none"
    fillRule="evenodd"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path stroke="#D6D7E0" strokeWidth={1.5} d="M60.498,2.882 L87.514,36.64" />
    <path stroke="#D6D7E0" strokeWidth={1.5} d="M49.831,2.136 L85.904,47.212" />
    <path stroke="#D6D7E0" strokeWidth={1.5} d="M41.566,6.15 L80.176,54.396" />
    <path stroke="#D6D7E0" strokeWidth={1.5} d="M35.839,13.336 L71.909,58.408" />
    <path stroke="#D6D7E0" strokeWidth={1.5} d="M34.226,23.904 L61.245,57.666" />
    <path stroke="#D6D7E0" strokeWidth={1.5} d="M34.101,23.732 L60.356,2.721" />
    <path stroke="#D6D7E0" strokeWidth={1.5} d="M34.819,32.811 L69.056,5.412" />
    <path stroke="#D6D7E0" strokeWidth={1.5} d="M37.843,40.045 L75.453,9.947" />
    <path stroke="#D6D7E0" strokeWidth={1.5} d="M41.767,46.558 L80.948,15.203" />
    <path stroke="#D6D7E0" strokeWidth={1.5} d="M47.261,51.815 L84.871,21.717" />
    <path stroke="#D6D7E0" strokeWidth={1.5} d="M54.245,55.879 L87.306,29.422" />
    <path stroke="#D6D7E0" strokeWidth={1.5} d="M63.54,58.095 L87.43,38.977" />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      points="91.135 61.062 84.276 66.55 100.241 86.499 107.1 81.01"
    />
    <path
      stroke="#283060"
      strokeWidth={1.5}
      d="M88.98,72.179 L92.135,62.061"
      opacity={0.200000003}
    />
    <path
      stroke="#283060"
      strokeWidth={1.5}
      d="M93.98,78.179 L97.135,68.061"
      opacity={0.200000003}
    />
    <path
      stroke="#283060"
      strokeWidth={1.5}
      d="M98.98,84.179 L102.135,74.061"
      opacity={0.200000003}
    />
    <polygon
      stroke="#1C1F34"
      strokeWidth={3}
      points="91.135 61.062 84.276 66.55 100.241 86.499 107.1 81.011"
    />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      points="111.373 84.592 102.798 91.454 101.434 89.749 100.241 86.5 107.1 81.011 110.009 82.887"
    />
    <polygon
      stroke="#1C1F34"
      strokeWidth={3}
      points="111.373 84.592 102.798 91.454 101.434 89.749 100.241 86.5 107.1 81.011 110.009 82.887"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M89.499,62.371 C89.499,62.371 88.693,59.276 87.47,54.011 C86.246,48.747 88.345,34.727 88.345,34.727"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M85.913,65.241 C85.913,65.241 83.07,63.776 78.201,61.429 C73.333,59.081 59.195,58.055 59.195,58.055"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M80.461,14.596 C69.799,1.273 52.385,-2.508 41.566,6.15 C30.746,14.809 30.619,32.628 41.28,45.951 C51.942,59.274 69.356,63.055 80.176,54.397 C90.995,45.738 91.123,27.919 80.461,14.596 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M14.493,34.159 C12.608,33.262 10.917,31.798 9.957,30.176 C7.885,26.678 9.992,23.767 13.49,21.696 C16.989,19.624 20.554,19.176 22.626,22.674 C23.221,23.68 23.629,24.903 23.824,26.184"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M14.493,34.159 C12.608,33.262 10.917,31.798 9.957,30.176 C7.885,26.678 9.992,23.767 13.49,21.696 C16.989,19.624 20.554,19.176 22.626,22.674 C23.221,23.68 23.629,24.903 23.824,26.184"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M30.99,88.239 L39.466,86.966 L39.587,77.845 L44.566,71.817 L51.328,69.473 C51.328,69.473 55.128,72.269 59.043,69.473 C62.957,66.677 58.831,50.52 47.414,47.841 L30.99,52.398 L14.566,47.841 C3.149,50.52 -0.977,66.677 2.937,69.473 C6.852,72.269 10.652,69.473 10.652,69.473 L17.414,71.817 L22.393,77.845 L22.514,86.966 L30.99,88.239 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#283060"
      d="M43.568,50.193 C41.968,55.609 37.315,59.021 30.99,59.021 C26.109,59.021 22.223,56.988 19.966,53.572 C19.276,53.128 18.657,52.468 18.174,51.546 C17.324,49.923 16.245,48.643 15.24,47.38 C15.923,55.855 22.203,61.648 30.99,61.648 C39.368,61.648 45.456,56.375 46.598,48.538 C45.878,49.458 44.782,50.009 43.568,50.193"
      opacity={0.2}
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M47.487,34.159 C49.372,33.262 51.063,31.798 52.023,30.176 C54.095,26.678 51.988,23.767 48.49,21.696 C44.991,19.624 41.426,19.176 39.354,22.674 C38.759,23.68 38.351,24.903 38.156,26.184"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M47.487,34.159 C49.372,33.262 51.063,31.798 52.023,30.176 C54.095,26.678 51.988,23.767 48.49,21.696 C44.991,19.624 41.426,19.176 39.354,22.674 C38.759,23.68 38.351,24.903 38.156,26.184"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M45.73,30.849 C46.572,30.382 47.344,29.658 47.804,28.88 C48.798,27.203 47.964,25.912 46.504,25.048 C45.045,24.183 43.512,24.073 42.519,25.75 C42.233,26.233 42.023,26.81 41.904,27.409"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M16.25,30.849 C15.408,30.382 14.636,29.658 14.176,28.88 C13.182,27.203 14.016,25.912 15.476,25.048 C16.935,24.183 18.468,24.073 19.461,25.75 C19.747,26.233 19.957,26.81 20.076,27.409"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M21.5,76.857 C23.903,82.393 21.874,88.607 16.969,90.735 C12.065,92.864 6.141,90.102 3.738,84.566 C1.335,79.029 3.364,72.816 8.269,70.687 C13.173,68.558 19.097,71.321 21.5,76.857"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M21.5,76.857 C23.903,82.393 21.874,88.607 16.969,90.735 C12.065,92.864 6.141,90.102 3.738,84.566 C1.335,79.029 3.364,72.816 8.269,70.687 C13.173,68.558 19.097,71.321 21.5,76.857 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M40.48,76.857 C38.078,82.393 40.106,88.607 45.011,90.735 C49.916,92.864 55.84,90.102 58.242,84.566 C60.645,79.029 58.617,72.816 53.712,70.687 C48.807,68.558 42.883,71.321 40.48,76.857"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M44.323,78.525 C42.813,82.005 43.844,85.806 46.627,87.013 C49.41,88.221 52.89,86.379 54.4,82.898 C55.911,79.418 54.879,75.618 52.097,74.41 C49.314,73.202 45.833,75.045 44.323,78.525"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M17.657,78.525 C19.168,82.005 18.137,85.806 15.354,87.013 C12.57,88.221 9.091,86.379 7.58,82.898 C6.069,79.418 7.101,75.618 9.884,74.41 C12.666,73.202 16.148,75.045 17.657,78.525"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M40.48,76.857 C38.078,82.393 40.106,88.607 45.011,90.735 C49.916,92.864 55.84,90.102 58.242,84.566 C60.645,79.029 58.617,72.816 53.712,70.687 C48.807,68.558 42.883,71.321 40.48,76.857 Z"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M21.745,86.968 C24.519,87.781 27.661,88.24 30.99,88.24 C34.321,88.24 37.465,87.781 40.24,86.967"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={1.5}
      d="M17.145,52.396 C12.674,56.504 10.652,62.117 10.652,69.473 C10.652,69.664 10.654,69.854 10.658,70.044"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={1.5}
      d="M51.322,70.043 C51.326,69.854 51.328,69.663 51.328,69.473 C51.328,62.117 49.311,56.508 44.837,52.398"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M10.652,69.473 C10.652,69.473 6.852,72.269 2.937,69.473 C-0.977,66.677 3.167,50.698 14.583,48.019"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M51.328,69.473 C51.328,69.473 55.128,72.269 59.043,69.473 C62.957,66.677 58.831,50.52 47.414,47.841"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M47.551,41.37 C47.551,31.594 40.766,25.107 30.991,25.107 C21.215,25.107 14.43,31.594 14.43,41.37 C14.43,51.146 21.215,57.93 30.991,57.93 C40.766,57.93 47.551,51.146 47.551,41.37"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M40.541,48.379 C40.541,43.104 36.265,41.045 30.99,41.045 C25.715,41.045 21.439,43.104 21.439,48.379 C21.439,53.654 25.715,57.93 30.99,57.93 C36.265,57.93 40.541,53.654 40.541,48.379"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M47.551,41.37 C47.551,31.594 40.766,25.107 30.991,25.107 C21.215,25.107 14.43,31.594 14.43,41.37 C14.43,51.146 21.215,57.93 30.991,57.93 C40.766,57.93 47.551,51.146 47.551,41.37 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#1C1F34"
      d="M34.084,46.03 C34.084,44.321 32.699,43.895 30.99,43.895 C29.282,43.895 27.897,44.321 27.897,46.03 C27.897,47.739 29.282,49.124 30.99,49.124 C32.699,49.124 34.084,47.739 34.084,46.03"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#1C1F34"
      d="M40.516,38.921 C40.516,37.758 39.573,36.815 38.41,36.815 C37.247,36.815 36.304,37.758 36.304,38.921 C36.304,40.084 37.247,41.027 38.41,41.027 C39.573,41.027 40.516,40.084 40.516,38.921"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#1C1F34"
      d="M25.677,38.921 C25.677,37.758 24.733,36.815 23.57,36.815 C22.407,36.815 21.465,37.758 21.465,38.921 C21.465,40.084 22.407,41.027 23.57,41.027 C24.733,41.027 25.677,40.084 25.677,38.921"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#E8EBF7"
      d="M81.733,88.787 C85.289,85.231 85.289,79.465 81.733,75.909 C78.177,72.353 72.411,72.353 68.855,75.909 C65.299,79.465 65.299,85.231 68.855,88.787 C72.411,92.343 78.177,92.343 81.733,88.787"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M81.733,88.787 C85.289,85.231 85.289,79.465 81.733,75.909 C78.177,72.353 72.411,72.353 68.855,75.909 C65.299,79.465 65.299,85.231 68.855,88.787 C72.411,92.343 78.177,92.343 81.733,88.787 Z"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={1.5}
      d="M76.701,73.859 C76.701,73.859 78.1,75.885 75.491,78.429 C72.882,80.972 69.849,78.618 66.257,83.719"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={1.5}
      d="M83.782,80.941 C83.782,80.941 81.757,79.542 79.213,82.151 C76.669,84.76 79.023,87.793 73.922,91.385"
    />
  </svg>
);

export default Toys;



// WEBPACK FOOTER //
// ./src/assets/images/icons/toys.js